<template>
	<div>
		<el-row class="container">
			<el-col class="" :xs="24" :sm="24" :md='24' :lg="24" :xl="24">
				<div class="nav-btn">
					<router-link v-for="(item,index) in navList" :to="`/news?id=${item.id}&name=${item.title}`">{{item.title}}</router-link>
				</div>
				<div class="Article-title">
					<h2>{{detail.title}}</h2>
					<div class="detail-top-btm"> 
						<div>浏览量：{{detail.view || 0}}</div>
						<div class="time-lable">日期：{{detail.created_at | time}}</div>
					</div>
				</div>
				<div class="news-detail" v-html="detail.content"></div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import moment from '@/utils/moment';
	import {
		Adv
	} from '@/api/adv';
	var adv = new Adv();
	export default {
		data() {
			return {
				detail: {},
				id: '',
				navList:[]
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.getNavBar();
			this.getDetail();
		},
		filters: {
			// 时间格式化
			time(val) {
				return moment(val * 1000).format('YYYY-MM-DD HH:mm');
			},
		},
		watch: {
			$route(to, from) {
				if (to.query.id != from.query.id) {
					this.id = to.query.id;
					this.getDetail();
				}
			}
		},
		methods: {
			//分类
			getNavBar(){
				var that = this;
				var param = {};
				adv.navbar(param).then(data => {
					that.navList = that.navList.concat(data.data);
				}).catch((res) => {
				});
			},
			getDetail() {
				var param = {
					id: this.id
				};
				adv.adDetail(param).then(res => {
					this.detail = res.data;
					//只有一个规格值时，默认选中

				}).catch(() => {
					console.log(77)
				})
			}
		}
	}
</script>
<style scoped>
	.news-detail {
		padding: 20px 0;
	}

	.view-content img {
		margin: 0 0 !important;
		max-width: 100% !important;
	}
	.Article-title {
	    text-align: center;
	    border-bottom: 1px dashed #d1d1d1;
	    padding-bottom: 15px;
	    margin-bottom: 15px;
		margin-top: 20px;
	}
	.Article-title h2 {
	    color: #333;
	    font-size: 18px;
	}
	.nav-btn{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.nav-btn a{
		color: #2c3096;
		font-size: 14px;
		line-height: 35px;
		padding: 0 12px;
		display: block;
		border: 1px solid #2c3096;
		border-radius: 5px;
		margin: 0 4px 8px;
		cursor: pointer;
	}
	.detail-top-btm{
		display: flex;
		justify-content: center;
	}
	.time-lable{
		margin-left: 20px;
	}
	.news-detail>>>img{
		max-width: 100% !important;
	}
</style>